export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/comment-solid-77816a77e8f421e9d0c8836e3d1c63d8.svg";